let headerNavContainer = document.querySelector('.frge-header-nav');
let headerMenuLi = [];
if (headerNavContainer) {
    headerMenuLi = headerNavContainer.querySelectorAll('.menu-item');
}


let history = [];
let subMenuHistory = [];
let previousItemClicked;
const backButton = document.querySelector('#back-button');
const svg = '<svg stroke-width="1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15 6L9 12L15 18" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path></svg>'

const openSearchIcon = document.querySelector('.header__search__open-icon');
const searchModal = document.querySelector('.search-modal');
const closeSearchIcon = document.querySelector('.frge-header-search-form__close-icon');
const bodyFilter = document.querySelector('.body-brighntess-filter');

const NotFoundSearchOpenModal = document.querySelector('.not-found__open-search');

if (NotFoundSearchOpenModal) {
    NotFoundSearchOpenModal.addEventListener('click', function (event) {
        event.preventDefault();
        searchModal.classList.toggle('is-open');
        document.body.classList.toggle('no-scroll');
        bodyFilter.classList.toggle('is-active');
    });
}

openSearchIcon.addEventListener('click', function (event) {
    searchModal.classList.toggle('is-open');
    document.body.classList.toggle('no-scroll');
    if (bodyFilter) {
        bodyFilter.classList.toggle('is-active');
    }
})

closeSearchIcon.addEventListener('click', function (event) {
    searchModal.classList.toggle('is-open');
    document.body.classList.toggle('no-scroll');
    if (bodyFilter) {

        bodyFilter.classList.toggle('is-active');
    }
});
headerMenuLi.forEach(function (item, index) {
    const span = item.querySelector('span');
    if (span === null) return;

    if (item.classList.contains('has-children')) {
        span.addEventListener('click', function (event) {
            item.querySelector('.sub-menu').classList.remove('hidden');
            item.querySelector('.sub-menu').classList.add('visible');
            let parentItem = item.parentNode;
            let firstLevelLi = parentItem.querySelectorAll(':scope > li');
            firstLevelLi = Array.from(firstLevelLi);
            firstLevelLi.push(item.querySelector("span"));

            firstLevelLi.forEach(function (li) {
                if (li !== item) {
                    li.classList.toggle('hidden');
                }
            });

            history.push({
                items: firstLevelLi,
            });

            subMenuHistory.push({
                item: item.querySelector('.sub-menu'),
            })

            if (history.length == 1) {
                backButton.classList.toggle('hidden');
            } else if (history.length > 1) {
                backButton.innerHTML = svg + previousItemClicked;
            } else {
                backButton.innerHTML = svg + 'Retour';
            }

            previousItemClicked = span.innerText;
        });
    }
});


backButton.addEventListener('click', function (event) {
    if (history.length === 0) return;

    history[history.length - 1]['items'].forEach(function (item) {
        if (item.classList.contains('hidden')) {
            item.classList.remove('hidden');
            subMenuHistory[subMenuHistory.length - 1]['item'].classList.remove('visible');
            subMenuHistory[subMenuHistory.length - 1]['item'].classList.add('hidden');
        }
    })

    history.pop();
    subMenuHistory.pop();

    if (history.length > 1) {
        backButton.innerHTML = svg + previousItemClicked;
    } else {
        backButton.innerHTML = svg + 'Retour';
    }

    if (history.length === 0) {
        backButton.classList.toggle('hidden');
    }
})


//Toggle menu
const headerMenuContainer = document.querySelector('.header-menu-container');
const menuToggleButton = document.querySelector('.header__menu-icon');
const menuCloseButton = document.querySelector('.header-menu-container__close-btn');

function toggleMenu() {

    menuToggleButton.addEventListener('click', function (event) {
        headerMenuContainer.classList.toggle('is-open');
        document.body.classList.toggle('no-scroll');
    })

    menuCloseButton.addEventListener('click', function (event) {
        headerMenuContainer.classList.toggle('is-open');
        document.body.classList.toggle('no-scroll');
    });

    if (window.innerWidth > 600) {
        // Ajout du gestionnaire d'évènements pour le document
        document.addEventListener('click', function (event) {
            // Vérifie si le menu est ouvert et si le clic s'est produit en dehors du menu
            if (headerMenuContainer.classList.contains('is-open') && !headerMenuContainer.contains(event.target) && !menuToggleButton.contains(event.target)) {
                headerMenuContainer.classList.remove('is-open');
                document.body.classList.remove('no-scroll');
            }
        });
    }


}

toggleMenu();

//Header top background 
const headerTop = document.querySelector('.header__top');
if (document.body.classList.contains('home') || document.body.classList.contains('blog') || document.body.classList.contains('archive') || document.body.classList.contains('page-template-page-offres-emploi-php')) {
    if (document.body.classList.contains('logged-in')) {
        const adminBar = document.querySelector('#wpadminbar');
        headerTop.style.marginTop = adminBar.offsetHeight + 'px';
    }
    window.addEventListener('scroll', function (event) {
        headerTopBackground();
    });
    headerTopBackground();

    function headerTopBackground() {
        if (window.scrollY <= 0) {
            headerTop.style.backgroundColor = 'transparent';
        } else {
            headerTop.style.backgroundColor = '#0B4F78';
        }
    }
} else {
    let mainDiv = document.body.querySelector('main');
    headerTop.style.backgroundColor = '#0B4F78';
    if (document.body.classList.contains('logged-in')) {
        const adminBar = document.querySelector('#wpadminbar');
        mainDiv.style.paddingTop = headerTop.offsetHeight - adminBar.offsetHeight + 'px';
    } else {
        mainDiv.style.paddingTop = headerTop.offsetHeight + 'px';
    }
}

